import React, { useState } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { apiFetch, doCallback } from 'functions.js';

// CONTEXT
import { useRecordContext } from 'helpers/getRecordData';

// CORE COMPONENTS
import Form from 'core/form/Form';

// STYLES
import styles from './dealTaskCommentForm.module.scss';

// MAIN COMPONENT
const DealTaskCommentForm = ({
  taskID
}) => {

  // CONTEXT
  const { refetchRecord } = useRecordContext() || {};

  // STATE
  const [ comment, setComment ] = useState();

  // CALLBACKS
  const handleClick = () => {
    apiFetch({
      method: 'POST',
      endpoint: ENDPOINTS.dealTasks.comment.add,
      params: {
        task_id: taskID,
        comments: comment
      },
      loadingMessage: 'Adding comment',
      successMessage: 'Comment added.',
      errorMessage: 'Unable to add comment.',
      onSuccess: () => {
        doCallback(refetchRecord);
        setComment();
      }
    });
  }

  // RENDER
  return (
    <div className={styles.commentForm}>
      <Form.Body>
        <Form.Control
          className={clsx(
            styles.commentInput,
            !!comment && styles.enabled
          )}
          value={comment}
          placeholder="Type your comment here"
          onChange={e => setComment(e.target.value)}
          append={{
            use: 'send',
            className: styles.append,
            onClick: !!comment ? handleClick : undefined
          }}
          fullWidth
        />
      </Form.Body>
    </div>
  );
};

// EXPORT
export default DealTaskCommentForm;
